import { render, staticRenderFns } from "./NoteDialog.vue?vue&type=template&id=2eb1b088&"
import script from "./NoteDialog.vue?vue&type=script&lang=ts&"
export * from "./NoteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NoteDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports